import {instance} from "../fetch";
import {API_URL} from "../../constants/axios";

/**
 * 고지서 열람 링크(로그인 없이 쓰는 모바일 고지서, 2026-10-02) API.
 *
 * ⚠️ **`fetchApi` 가 아니라 `instance` 를 쓴다** — `cardLink.api.js` 와 같은 이유.
 * `fetchApi` 는 토큰 헤더를 붙이고 401 을 로그인 화면으로 돌린다. 이 화면은 로그인하지 않은 사장님이 연다.
 */

/** 링크가 유효한가 + 업체명·브랜드·이용월. 🔴 금액·사업자등록번호는 응답에 없다. */
export const getInvoiceLinkInfo = async (token) => {
    const res = await instance.get(`${API_URL.INVOICE_LINK_INFO}?t=${encodeURIComponent(token)}`);
    return res.data;
};

/** 사업자등록번호 확인. 통과하면 `data.invoice` 에 그 달 확정 고지서가 담긴다. */
export const verifyInvoiceLink = async (token, bizRegNumber) => {
    const res = await instance.post(API_URL.INVOICE_LINK_VERIFY, {token, bizRegNumber});
    return res.data;
};
